import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import { BaseAnalyticsApi } from './baseAnalyticsApi'
import type {
  AnalyticsResponse,
  IAnalyticsParams,
  ICreditUsageChartResponse,
  ICreditUsageStatisticResponse,
  IParamsCreditUsageAnalyticsList,
  IParamsCreditUsageList,
  IResponseCreditUsageAnalyticsDetails,
  IResponseCreditUsageAnalyticsList,
} from './types'

class CreditUsageApi extends BaseAnalyticsApi<
  ICreditUsageStatisticResponse,
  ICreditUsageChartResponse
> {
  constructor() {
    super('credits-usage', 'core')
  }

  preloadCreditUsageAnalytics = (
    params: IAnalyticsParams,
    options?: AxiosOptions
  ): Promise<
    AxiosResponse<AnalyticsResponse<ICreditUsageStatisticResponse, ICreditUsageChartResponse>>
  > => {
    return baseApi.get('analytics/credits/usage-totals', {
      params: {
        ...params,
        preload_type: 'previous',
      },
      ...options,
    })
  }

  getCreditUsageAnalytics = (
    params: IAnalyticsParams,
    options?: AxiosOptions
  ): Promise<
    AxiosResponse<AnalyticsResponse<ICreditUsageStatisticResponse, ICreditUsageChartResponse>>
  > => {
    return baseApi.get('analytics/credits/usage-totals', {
      params,
      ...options,
    })
  }

  getCreditUsageAnalyticsList = (
    params: IParamsCreditUsageAnalyticsList,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseCreditUsageAnalyticsList>> => {
    return baseApi.get('analytics/credits/usage-list', {
      params,
      ...options,
    })
  }

  getCreditUsageAnalyticsDetails = (
    params: IParamsCreditUsageList[]
  ): Promise<AxiosResponse<IResponseCreditUsageAnalyticsDetails>> => {
    return baseApi.post('core/analytics/credits-usage/details', params)
  }
}

export const CreditUsageAnalyticsApi = new CreditUsageApi()
